import { normalizeSupplierTier } from './companyDisplayUtils';

export const SUPPLIER_TIER_KEYS = ['1', '2', '3'];

export function computeSupplierTierCounts(companies = []) {
  const counts = { 1: 0, 2: 0, 3: 0 };
  (Array.isArray(companies) ? companies : []).forEach((company) => {
    const tier = normalizeSupplierTier(company?.tier ?? company?.supplier_tier);
    if (tier === '1' || tier === '2' || tier === '3') {
      counts[tier] += 1;
    }
  });
  return counts;
}
